/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Asse di presentazione (rendering FE) dell\'attributo dichiarato dal bando
 */
export enum UiWidget {

    TEXT_INPUT = 'TEXT_INPUT',

    DATE_PICKER = 'DATE_PICKER',

    DROPDOWN = 'DROPDOWN',

    RADIO_GROUP = 'RADIO_GROUP',

    SINGLE_CHECKBOX = 'SINGLE_CHECKBOX',

    NUMBER_INPUT = 'NUMBER_INPUT',

    FILE_UPLOAD = 'FILE_UPLOAD'
}

